import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '100%',
        flexGrow: 1
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
    listaCapitulos: {
        marginTop: '10px',
        marginBottom: '10px',
    }
});

export default function LivroCapituloProfile({ capitulo }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <Grid container spacing={3}>
                    <Grid size={3}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Livro
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {capitulo.livro.descricao}
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Série
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {capitulo.livro.serie.descricao}
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Disciplina
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {capitulo.livro.disciplina.descricao}
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Capítulo
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {capitulo.descricao}
                        </Typography>
                    </Grid>
                </Grid>
                <CardActions>
                    <Link to={{
                        pathname: '/livro-capitulos',
                        state: {
                            livro: capitulo.livro
                        }
                    }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.listaCapitulos}>
                            Lista Capítulos
                        </Button>
                    </Link>
                </CardActions>

            </CardContent>
        </Card>
    );
}